import React from 'react';
import { Hero } from '../components/Hero';
import { LeadSavedShowcase } from '../components/showcase/LeadSavedShowcase';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorksTeaser } from '../components/HowItWorksTeaser';
import { Proof } from '../components/Proof';
import { Guarantee } from '../components/Guarantee';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('Viridia Analytics | Every real estate lead answered in under 60 seconds');
  return <>
      <Hero data-id="element-390" data-mp="29flrk1ujboxw" />
      <LeadSavedShowcase data-id="element-391" data-mp="29fvh5obo3u32" />
      <ProblemSection data-id="element-392" data-mp="29ek4ez08vbzt" />
      <HowItWorksTeaser data-id="element-393" data-mp="29i7v7qeb1kau" />
      <Proof data-id="element-394" data-mp="2dhgt97gdo4c7" />
      <Guarantee data-id="element-395" data-mp="2dhywwp5ddku5" />
      <CtaBand data-id="element-396" data-mp="2dii3j9pkkmsv" />
    </>;
}